import { useState } from 'react';

import Button from 'components/field/Button';
import Tooltip from 'components/global/Tooltip';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faFilter, faList } from '@fortawesome/pro-light-svg-icons';

import TableColumnsMenu from './TableColumnsMenu';
import TableFilterMenu from './TableFilterMenu';
import TableFilters from './TableFilters';
import * as S from './TableHeader.styled';

const TableHeader = (props) => {
	const { table, columns, storedColumns, setStoredColumns, columnFilters, setColumnFilters, storageKey } = props;

	const isMobile = useMediaQuery(Breakpoints.mobile);
	const [columnsMenuButtonRef, setColumnsMenuButtonRef] = useState(null);
	const [filtersMenuButtonRef, setFiltersMenuButtonRef] = useState(null);

	return (
		<S.MenuContainer>
			<S.FiltersContainer>
				<TableFilters
					table={table}
					columnFilters={columnFilters}
					setColumnFilters={setColumnFilters}
					storageKey={storageKey}
				/>
			</S.FiltersContainer>

			<div style={{ flexGrow: 1 }} />

			<Tooltip title="filter" placement="top">
				<Button
					id="table-filter-button"
					className="table-filter-button"
					ref={setFiltersMenuButtonRef}
					icon={faFilter}
					iconSize="medium"
					variant={isMobile ? 'action' : 'borderless'}>
					{columnFilters?.length > 0 && <S.MobileFilterDot />}
				</Button>
			</Tooltip>
			<TableFilterMenu
				table={table}
				columnFilters={columnFilters}
				setColumnFilters={setColumnFilters}
				filtersMenuButtonRef={filtersMenuButtonRef}
			/>

			<Tooltip title="columns" placement="top">
				<Button
					id="table-columns-button"
					className="table-columns-button"
					ref={setColumnsMenuButtonRef}
					icon={faList}
					iconSize="medium"
					variant={isMobile ? 'action' : 'borderless'}
				/>
			</Tooltip>
			<TableColumnsMenu
				table={table}
				columns={columns}
				storedColumns={storedColumns}
				setStoredColumns={setStoredColumns}
				columnsMenuButtonRef={columnsMenuButtonRef}
			/>
		</S.MenuContainer>
	);
};

export default TableHeader;
